import { useState } from "react";
import { toast } from "sonner";
import { Lightbulb, Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { inputCls } from "@/components/hub/Common";

export const SUG_CATS = ["feature", "effect", "platform", "ai", "ux", "other"];

export const SuggestionForm = ({ onPosted }) => {
  const { t } = useI18n();
  const [f, setF] = useState({ title: "", body: "", category: "feature" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/suggestions", f);
      toast.success(t("sug.posted"));
      setF({ title: "", body: "", category: "feature" });
      onPosted();
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="cx-card cx-brackets rounded-2xl p-6 space-y-4" data-testid="suggestion-form">
      <div className="flex items-center gap-2 font-display text-lg text-white"><Lightbulb className="w-5 h-5 text-[#ffc94d]" />{t("sug.new")}</div>
      <input data-testid="suggestion-title-input" className={inputCls} placeholder={t("sug.f_title")} value={f.title} onChange={(e) => setF({ ...f, title: e.target.value })} required minLength={4} maxLength={120} />
      <textarea data-testid="suggestion-body-input" className={`${inputCls} min-h-[120px] resize-y`} placeholder={t("sug.f_body")} value={f.body} onChange={(e) => setF({ ...f, body: e.target.value })} required minLength={10} maxLength={2000} />
      <div>
        <div className="cx-label mb-2">{t("sug.f_category")}</div>
        <div className="flex flex-wrap gap-2">
          {SUG_CATS.map((c) => (
            <button type="button" key={c} data-testid={`suggestion-cat-${c}`} onClick={() => setF({ ...f, category: c })}
              className={`rounded-full px-3 py-1.5 text-xs border transition-colors ${f.category === c ? "border-[#3ad7ff] text-[#3ad7ff] bg-[#3ad7ff]/10" : "border-white/10 text-slate-400 hover:text-white"}`}>{t(`sug.cat_${c}`)}</button>
          ))}
        </div>
      </div>
      <button type="submit" disabled={busy} data-testid="suggestion-submit-btn" className="cx-btn w-full rounded-full py-3 font-display font-semibold flex items-center justify-center gap-2">
        {busy && <Loader2 className="w-4 h-4 animate-spin" />}{t("sug.submit")}
      </button>
    </form>
  );
};
